module.exports = __webpack_public_path__ + "static/media/user_green.333145c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_green.svg
// module id = 204
// module chunks = 0